'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Footer = require('./Footer.scss');

var _Footer2 = _interopRequireDefault(_Footer);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _customize = require('redux/modules/customize');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  ZHFooter: {
    displayName: 'ZHFooter'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Footer/ZHFooter.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var ZHFooter = _wrapComponent('ZHFooter')((_dec = (0, _reactRedux.connect)(null, { logCustomizeTrip: _customize.logCustomizeTrip }), _dec2 = (0, _reactCssModules2.default)(_Footer2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ZHFooter, _Component);

  function ZHFooter() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ZHFooter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ZHFooter.__proto__ || (0, _getPrototypeOf2.default)(ZHFooter)).call.apply(_ref, [this].concat(args))), _this), _this.openCustomizeTrip = function () {
      _this.props.logCustomizeTrip('footer');
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ZHFooter, [{
    key: 'render',
    value: function render() {
      return _react3.default.createElement(
        'footer',
        { styleName: 'footer' },
        _react3.default.createElement(
          'div',
          { styleName: 'footer-container' },
          _react3.default.createElement('div', { styleName: 'social-container' }),
          _react3.default.createElement(
            'p',
            { styleName: 'footer-p' },
            _react3.default.createElement('img', { styleName: 'wechat-qr', src: require('components/Popup/wechat-qr.png') })
          ),
          _react3.default.createElement(
            'p',
            { styleName: 'footer-p' },
            _react3.default.createElement('img', { styleName: 'wechat-logo', src: require('./wechat.png'), alt: 'Wechat icon' }),
            '\u5FAE\u4FE1ID: takemetour'
          ),
          _react3.default.createElement(
            'p',
            { styleName: 'footer-p' },
            _react3.default.createElement(
              _Link2.default,
              { onClick: this.openCustomizeTrip, to: '/customize' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.home_landing.customize_link' })
            )
          )
        )
      );
    }
  }]);
  return ZHFooter;
}(_react2.Component), _class2.propTypes = {
  logCustomizeTrip: _react2.PropTypes.func
}, _temp2)) || _class) || _class));

exports.default = ZHFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/ZHFooter.js
// module id = 1521
// module chunks = 47